import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./index.css";
import CalendarPicker from "rc-calendar";
import axios from 'axios'
import DropdownMenu from '../DropdownMenu';
class View_type_3 extends Component {
    constructor(props) {
        super(props);

        var data = { list: [], ...props.data };

        this.state = {
            // counter:this.state.items_per_page ? this.state.items_per_page : null,
            data: data,
            width: 0,
            height: 0,
            isVisible: true,
            counter: data.items_per_page ? data.items_per_page : null,
            counterSecond: 0,
            counterX: 1,
        };
       // console.log("View_type_3: ", this.state);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);


    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState(() => {
            return {
                width: window.innerWidth,
                heigth: window.innerHeight
            };
        });
    }

    updateHandler = () => {
        this.updateNews();
    }
    updateNews = () => {
        let offset = this.state.data.items_per_page;
        let counter = this.state.counterX;
        this.setState(() => {
            return {
                counterX: counter += 1
            };
        });
        axios
            .get(
                `${this.state.data.button_lazy_load.url}${this.state.counter
                }?lang=${this.state.data.button_lazy_load.lang}&offset=${offset * this.state.counterX}`
            )
            .then(res => {
                const data = res.data;
                if (res.data.list.length) {
                    this.setState({
                        data: {
                            ...this.state.data,
                            list: this.state.data.list.concat(data.list)
                        },
                        counter: this.state.counter + 9,
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    isVisible: false
                })
            })
    };

    render() {
        var object = this.state.data;

        if (object.length) {

            return (
                <div className="vt3">
                    <div className="vt3 row middle-scrollPoint">
                        {object.map(function (object, i) {
                            return (
                                <div className="vt3 list-block">
                                    <div className="vt3 title">{object.header}</div>
                                    {object.list && object.list.map(function (news, index) {
                                        index++;
                                        var category = news.category;
                                        var title = news.title;
                                        var description = news.description;
                                        var color = news.color;
                                        var image = news.image;
                                        var url = news.url;
                                        if (index !== 0 && index % 3 === 0) {
                                            return (
                                                <div key={index} className="small--inline">
                                                    <div className="vt3 wrapped-item col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                        <div className="vt3 middle-postblock"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => window.location.href = `/${url}`}
                                                        >
                                                            <div className="vt3">
                                                                <img className="vt3-img" src={image} alt="" />
                                                                <div className="vt3 middlepost-thumbnail" />
                                                                <div
                                                                    className="vt3 load-element"
                                                                    style={{ backgroundColor: color }}
                                                                />
                                                            </div>
                                                            <p
                                                                className="vt3 middlepost-titldesc"
                                                                style={{ color: color }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: category.toUpperCase()
                                                                }}
                                                            />
                                                            <p
                                                                className="vt3 middlepost-titleitem"
                                                                dangerouslySetInnerHTML={{ __html: title }}
                                                            />
                                                            <p
                                                                className="vt3 middlepost-description"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: description
                                                                }}
                                                            />
                                                            <div className="vt3 middle-addelem">
                                                                <Link
                                                                    className="vt3 more_button"
                                                                    to={"/" + url}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="clearfix" />
                                                </div>
                                            );
                                        }
                                        return (
                                            <div
                                                className="vt3 wrapped-item col-xs-6 col-sm-6 col-md-4 col-lg-4"
                                                key={index}
                                            >
                                                <div className="vt3 middle-postblock"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.location.href = `/${url}`}>
                                                    <div className="vt3">
                                                        <img className="vt3-img" src={image} alt="" />
                                                        <div className="vt3 middlepost-thumbnail" />
                                                        <div
                                                            className="vt3 load-element"
                                                            style={{ backgroundColor: color }}
                                                        />
                                                    </div>
                                                    <p
                                                        className="vt3 middlepost-titldesc"
                                                        style={{ color: color }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: category.toUpperCase()
                                                        }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-titleitem"
                                                        dangerouslySetInnerHTML={{ __html: title }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-description"
                                                        dangerouslySetInnerHTML={{ __html: description }}
                                                    />
                                                    <div className="vt3 middle-addelem">
                                                        <Link className="vt3 more_button" to={"/" + url} />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
            // }
        } else if (this.state.data.category == "compositions") {
            return (
                <div className="vt3 ">
                    <div className="vt3 row middle-scrollPoint">
                        <div className="vt3 list-block ">
                            <div className="vt3 title">{object.header}</div>
                            {object.list && object.list.map(function (news, index) {
                                index++;
                                var category = news.category;
                                var title = news.title;
                                var description = news.description;
                                var color = news.color;
                                var image = news.image;
                                var aptext = news.apla_text;
                                var apbg = news.apla_background_color;
                                var url = news.url;
                                if (index !== 0 && index % 3 === 0) {
                                    return (
                                        <div key={index} className="small--inline">
                                            <div className="vt3 wrapped-item wrapped-item--compositions col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div className="vt3 middle-postblock"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.location.href = `/${url}`}
                                                >
                                                    <div className="vt3">
                                                        <img className="vt3-img" src={image} alt="" />
                                                        <div className="vt3 middlepost-thumbnail" />
                                                        <div
                                                            className="vt3 load-element"
                                                            style={{ backgroundColor: color }}
                                                        />

                                                    </div>
                                                    <p
                                                        className="vt3 middlepost-titldesc"
                                                        style={{ color: color }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: category.toUpperCase()
                                                        }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-titleitem"
                                                        dangerouslySetInnerHTML={{ __html: title }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-description"
                                                        dangerouslySetInnerHTML={{ __html: description }}
                                                    />
                                                    <div className="vt3 middle-addelem">
                                                        <Link className="vt3 more_button" to={"/" + url} />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="clearfix" /> */}
                                        </div>
                                    );
                                }
                                return (
                                    <div
                                        className="vt3 wrapped-item wrapped-item--compositions col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                        key={index}
                                    >
                                        <div className="vt3 middle-postblock"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => window.location.href = `/${url}`}
                                        >
                                            <div className="vt3">
                                                <img className="vt3-img" src={image} alt="" />
                                                <div className="vt3 middlepost-thumbnail" />
                                                <div
                                                    className="vt3 load-element"
                                                    style={{ backgroundColor: color }}
                                                />
                                            </div>
                                            <p
                                                className="vt3 middlepost-titldesc"
                                                style={{ color: color }}
                                                dangerouslySetInnerHTML={{
                                                    __html: category.toUpperCase()
                                                }}
                                            />
                                            <p
                                                className="vt3 middlepost-titleitem"
                                                dangerouslySetInnerHTML={{ __html: title }}
                                            />
                                            <p
                                                className="vt3 middlepost-description"
                                                dangerouslySetInnerHTML={{ __html: description }}
                                            />
                                            <div className="vt3 middle-addelem">
                                                <Link className="vt3 more_button" to={"/" + url} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="vt3 ">
                    <div className="vt3 row middle-scrollPoint col-xs-12 col-sm-12 col-md-12 col-lg-12 padd-0">
                        <div className="vt3 list-block">
                            <div className="vt3 title">{object.header}</div>
                            {object.list && object.list.map(function (news, index) {
                               // console.log(news)
                                index++;
                                var category = news.category;
                                var title = news.title;
                                var description = news.description;
                                var color = news.color;
                                var image = news.image;
                                var aptext = news.apla_text;
                                var apbg = news.apla_background_color;
                                var url = news.url;

                                if (index !== 0 && index % 3 === 0) {
                                    return (
                                        <div key={index} className="small--inline">
                                            <div className="vt3 wrapped-item col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                                <div className="vt3 middle-postblock"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.location.href = `/${url}`}
                                                >
                                                    <div className="vt3 wrapper">
                                                        <img className="vt3-img" src={image} alt="" />
                                                        <div className="vt3 apla" style={{ backgroundColor: apbg }}

                                                        />
                                                        <p className="vt3 apla apla-text"
                                                            dangerouslySetInnerHTML={{ __html: aptext }}
                                                        />
                                                        <div className="vt3 middlepost-thumbnail" />
                                                        <div
                                                            className="vt3 load-element"
                                                            style={{ backgroundColor: color }}
                                                        />
                                                    </div>
                                                    <p
                                                        className="vt3 middlepost-titldesc"
                                                        style={{ color: color }} //here color contrast
                                                        dangerouslySetInnerHTML={{
                                                            __html: category.toUpperCase()
                                                        }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-titleitem"
                                                        dangerouslySetInnerHTML={{ __html: title }}
                                                    />
                                                    <p
                                                        className="vt3 middlepost-description"
                                                        dangerouslySetInnerHTML={{ __html: description }}
                                                    />
                                                    <div className="vt3 middle-addelem">
                                                        <Link aria-label={title} className="vt3 more_button" to={"/" + url} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="clearfix" />
                                        </div>
                                    );
                                }
                                return (
                                    <div
                                        className="vt3 wrapped-item col-xs-6 col-sm-6 col-md-4 col-lg-4"
                                        key={index}
                                    >
                                        <div className="vt3 middle-postblock"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => window.location.href = `/${url}`}
                                        >
                                            <div className="vt3 wrapper">
                                                <img className="vt3-img" src={image} alt="" />
                                                <div className="vt3 apla" style={{ backgroundColor: apbg }}

                                                />
                                                <p className="vt3 apla apla-text"
                                                    dangerouslySetInnerHTML={{ __html: aptext }}
                                                />
                                                <div className="vt3 middlepost-thumbnail" />
                                                <div
                                                    className="vt3 load-element"
                                                    style={{ backgroundColor: color }}
                                                />
                                            </div>
                                            <p
                                                className="vt3 middlepost-titldesc"
                                                style={{ color: color}}
                                                dangerouslySetInnerHTML={{
                                                    __html: category.toUpperCase()
                                                }}
                                            />
                                            <p
                                                className="vt3 middlepost-titleitem"
                                                dangerouslySetInnerHTML={{ __html: title }}
                                            />
                                            <p
                                                className="vt3 middlepost-description"
                                                dangerouslySetInnerHTML={{ __html: description }}
                                            />
                                            <div className="vt3 middle-addelem">
                                                <Link aria-label={title} className="vt3 more_button" to={"/" + url} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {this.state.data.items_per_page && this.state.isVisible &&
                        <button style={{ background: window.globalColor }} className="button-load-news" onClick={this.updateHandler}>
                            {this.state.data.button_lazy_load ?
                                (this.state.data.button_lazy_load.text)
                                :
                                ("Pokaż kolejne artykuły")}
                        </button>
                    }


                </div>

            );
        }



    }
}
export default withRouter(View_type_3)



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_3/index.js